import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import SliderExperianLevelsStability from './CreateAlert.StepOne.SliderExperianLevelsStability';
import SliderExperianLevelsDelinquency from './CreateAlert.StepOne.SliderExperianLevelsDelinquency';
import {
    EXPERIAN_DEFAULT_SLIDER_LEVEL_STABILITY_RISK,
    EXPERIAN_DEFAULT_SLIDER_LEVEL_DELINQUENCY_RISK
} from './../../../constants';

export default class ExperianReportLevels extends Component {

    constructor(props) {
        super(props);

        this.changeExperianSliders = this.changeExperianSliders.bind(this);
    }

    changeExperianSliders(riskAngle) {
        let newRiskAngles = Object.assign({}, this.props.data.experianRiskAngles, riskAngle);
        this.props.saveData({'experianRiskAngles': newRiskAngles});
    }


    render() {

        return (
            <div className='experian-levels'>

                <div className='recent-bankruptcy'>
                    <FormattedMessage id='Alerts_Create_UIText_name.step1.experianSection.includeBankruptcy'/>
                </div>

                <div className='stability-risk'>
                    <SliderExperianLevelsStability changeExperianSliders={this.changeExperianSliders}
                                                   stabilityRisk={this.props.data.experianRiskAngles &&
                                                   this.props.data.experianRiskAngles.stabilityRisk >= 0 ?
                                                       this.props.data.experianRiskAngles.stabilityRisk :
                                                       EXPERIAN_DEFAULT_SLIDER_LEVEL_STABILITY_RISK} />
                </div>

                <div className='delinquency-risk'>
                    <SliderExperianLevelsDelinquency changeExperianSliders={this.changeExperianSliders}
                                                     delinquencyRisk={this.props.data.experianRiskAngles &&
                                                     this.props.data.experianRiskAngles.delinquencyRisk >= 0 ?
                                                         this.props.data.experianRiskAngles.delinquencyRisk :
                                                         EXPERIAN_DEFAULT_SLIDER_LEVEL_DELINQUENCY_RISK} />
                </div>

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/StepOneComponents/CreateAlert.StepOne.ExperianReportLevels.jsx